import _regeneratorRuntime from "/Volumes/VANE/marciano/studio4x4-suzuki-ecommerce/node_modules/@babel/runtime-corejs2/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Volumes/VANE/marciano/studio4x4-suzuki-ecommerce/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";
import { axiosInstance } from 'boot/axios.js';
export function addReview(_x) {
  return _addReview.apply(this, arguments);
}

function _addReview() {
  _addReview = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(ctx) {
    var queryParams,
        response,
        _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            queryParams = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
            _context.prev = 1;
            _context.next = 4;
            return axiosInstance({
              url: '/review',
              data: queryParams.data,
              method: 'POST'
            });

          case 4:
            response = _context.sent;
            return _context.abrupt("return", response);

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](1);
            return _context.abrupt("return", _context.t0);

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 8]]);
  }));
  return _addReview.apply(this, arguments);
}